import Modal from 'components/Modal/Modal';

export default Modal;
